import Item from './item';

import type { Offer } from '@rewardopl/types';

export default function Items({ items }: { items: Offer[] }) {
  return items.map((offer) => <Item key={offer._id} offer={offer} />);
}
